import { useElementTypes, type ElementType } from 'src/utilities/builder/element-types';
import { reactive } from 'vue';

export type BuilderPanel = 'FormSettings' | 'Workflow' | 'Payment' | 'FieldSettings';

export type SelectedField = {
	placeholderSelected: boolean;
	containerWidth: number;
	elementType?: ElementType;
	parentType?: ElementType;
	containerIndexes?: number[];
	fieldIndex?: number;
}

export type BuilderState = {
	currentPanel: BuilderPanel;
	selectedField: SelectedField | undefined;
	elementTypes: Record<keyof ReturnType<typeof useElementTypes>, ElementType>;
}

const getDefaultBuilderState = (): BuilderState => ({
	currentPanel: 'FormSettings',
	elementTypes: useElementTypes(),
	selectedField: undefined
});

export const resetBuilderState = (state: BuilderState) => {
	const defaultState = getDefaultBuilderState();
	Object.assign(state, defaultState);
};

export const useBuilderState = () => {
	const defaultState = getDefaultBuilderState();
	return reactive(defaultState);
};